$(  '[data-toggle="modal"]' ).click(function( event ) {
    event.preventDefault();

    var id = $( this ).attr( 'data-target' );
    $( id ).addClass( 'is-active' );
    $( 'body' ).addClass( 'is-blocked' );

});

$( '.modal__close, .modal__overlay' ).click(function( event ) {
    event.preventDefault();
    $( this ).closest( '.modal' ).removeClass( 'is-active' );
    $( 'body' ).removeClass( 'is-blocked' );
});